import React from "react";
import PropTypes from "prop-types";
import { COL_TYPE } from "../DialysisDragDrop.constants";
import { getStyle } from "./Table.utils";
import {
  DialysisDragDropContext,
  DialysisTableRef,
} from "../DialysisDragDrop.utils";
import { BandColumn } from "../BandColumn";
import { ScaleColumn } from "../ScaleColumn";

export function Table(props) {
  const { calculateHeight } = React.useContext(DialysisDragDropContext);

  React.useEffect(() => calculateHeight(DialysisTableRef.current), []);

  const getClassName = (type) => {
    return `dialysisDragDrop_table__${type.toLowerCase()}`;
  };

  const renderColumn = (column) => {
    switch (column.colType) {
      case COL_TYPE.SCALE_COLUMN:
        return (
          <ScaleColumn
            key={column.colId}
            colId={column.colId}
            colItems={column.colItems}
            className={getClassName(column.colType)}
            range={props.dialysisRange}
          />
        );
      case COL_TYPE.BAND_COLUMN:
        return (
          <BandColumn
            id={props.id}
            key={column.colId}
            colId={column.colId}
            colItems={column.colItems}
            headingAriaLabel={props.headingAriaLabel}
            className={getClassName(column.colType)}
            feedbackType={props.feedbackType}
            responses={props.responses}
          />
        );
      default:
        return null;
    }
  };

  const style = React.useMemo(
    () => getStyle(props.table),
    [props.table.length]
  );

  return (
    <>
      <div
        className="dialysisDragDrop_table"
        style={style}
        ref={DialysisTableRef}
      >
        {props.table.map(renderColumn)}
      </div>
      <p className="dialysisDragDrop_labelGroup">{props.xAxisLabel}</p>
    </>
  );
}

Table.propTypes = {
  /**
   * Component id from the notebook data file
   */
  id: PropTypes.number,
  /**
   * Label for the x-axis
   */
  xAxisLabel: PropTypes.string,
  /**
   * Data for dialysis Table
   */
  table: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unqiue id for the column
       */
      colId: PropTypes.number,
      /**
       * Type of column
       */
      colType: PropTypes.oneOf(Object.keys(COL_TYPE)),
      /**
       * Items in a column
       */
      colItems: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  /**
   * AriaLabel of the heading
   */
  headingAriaLabel: PropTypes.shape({
    /**
     * Unique key for the data
     */
    key: PropTypes.number,
    /**
     * Label of the Heading
     */
    label: PropTypes.string,
    /**
     * Arialabel to display on the heading
     */
    ariaLabel: PropTypes.string,
  }),
};

Table.defaultProps = {};
